// file: ./src/js/modules/cdc-gallery-glightbox-init.js

/**
 * CDC Gallery GLightbox Init JS
 * 
 * Inizializzazione di GLightbox per la galleria immagini
 * es. 'Gallery' nei single delle cooperative, CPT 'cooperative'.
 * ℹ → enqueue della libreria in 'functions.php'
 * 
 * @param {string} selector - Selettore CSS per gli elementi della galleria (default: '.glightbox-item')
 * 
 * @returns {object} - L'istanza di GLightbox inizializzata
 * 
 */
export default function initCDCGalleryGlightbox(selector = ".glightbox-item") {

    if (typeof GLightbox === "undefined") {
        console.warn("GLightbox non è definito.");
        return;
    }

    const lightbox = GLightbox({
        selector: selector || ".glightbox-item",
        touchNavigation: true,
        loop: true,
    });

    console.log("👍 GLightbox inizializzato");
    console.log("Galleria immagini con selettore:", selector);
    console.table("Oggetto lightbox:", lightbox);

    return lightbox;
}